import { useEffect } from 'react';


function useMountEffect(callback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
}

export default useMountEffect;
